/* Product reviews — star input, photo upload (client-side downscale), submit,
 * "show more" pagination and a photo lightbox. Progressive enhancement:
 * without JS the form is still a usable set of radios + inputs, and existing
 * reviews render server-side. All network writes go to the worker endpoint
 * (data-endpoint) — the theme never writes metafields. See CLAUDE.md §14. */
(function () {
  'use strict';

  var MAX_DIM = 1600;        // downscale longest edge to this many px
  var MAX_BYTES = 12 * 1024 * 1024; // reject source files larger than 12 MB

  function initSection(root) {
    if (root.__rvwInit) return;
    root.__rvwInit = true;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var cfg = readConfig(root);
    var MSG = cfg.msg || {};
    var endpoint = root.dataset.endpoint || '';
    var maxImages = parseInt(root.dataset.maxImages, 10) || 4;

    /* ---------- "więcej opinii" popup ---------- */
    var modal = $('[data-rvw-modal]');
    var lastFocus = null;
    function openModal() {
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.hidden = false; modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('is-locked');
      var closeBtn = modal.querySelector('[data-rvw-modal-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true; modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('is-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    var moreBtn = $('[data-rvw-more-open]');
    if (moreBtn) moreBtn.addEventListener('click', openModal);
    if (modal) {
      modal.querySelectorAll('[data-rvw-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }

    /* ---------- single-review quote popup (opened from a carousel card) ---------- */
    var quoteModal = $('[data-rvw-quote-modal]');
    var quoteBody = $('[data-rvw-quote-body]');
    var quoteLastFocus = null;
    function openQuote(slide) {
      if (!quoteModal || !quoteBody) return;
      var tpl = slide.querySelector('[data-rvw-quote-source]');
      if (!tpl) return;
      quoteBody.innerHTML = '';
      quoteBody.appendChild(tpl.content.cloneNode(true));
      quoteLastFocus = document.activeElement;
      quoteModal.hidden = false; quoteModal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('is-locked');
      var closeBtn = quoteModal.querySelector('[data-rvw-quote-modal-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeQuote() {
      if (!quoteModal) return;
      quoteModal.hidden = true; quoteModal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('is-locked');
      quoteBody.innerHTML = '';
      if (quoteLastFocus && quoteLastFocus.focus) quoteLastFocus.focus();
    }
    if (quoteModal) {
      quoteModal.querySelectorAll('[data-rvw-quote-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeQuote);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !quoteModal.hidden) closeQuote();
      });
    }

    /* ---------- 3D review carousel (ported from section-testimonials-3d-carousel).
       Click a side card to bring it to front; click the ACTIVE card to open its
       full text via openQuote(). Drag/swipe is tracked separately from taps so a
       swipe-release never accidentally opens the popup. Without JS the markup is
       a plain stacked list (real fallback) — .is-ready switches on the coverflow. */
    var ccWrapper = $('[data-rvw-carousel]');
    var ccViewport = $('[data-rvw-carousel-viewport]');
    var ccSlides = $$('[data-rvw-carousel-slide]');

    // A photo can fail to load for reasons outside the theme's control (a
    // freshly-uploaded file that hasn't finished propagating across Shopify's
    // CDN yet, a dropped request, ...). Never show a broken-image glyph —
    // fall back to the same initial-letter tile used when there's no photo.
    $$('[data-rvw-carousel-img]').forEach(function (img) {
      img.addEventListener('error', function () {
        var fallback = document.createElement('span');
        fallback.className = 'rvw-carousel__avatar-fallback';
        fallback.textContent = img.getAttribute('data-fallback-letter') || '?';
        if (img.parentNode) img.parentNode.replaceChild(fallback, img);
      }, { once: true });
    });

    if (ccViewport && ccSlides.length) {
      var ccCurrent = 0;
      var ccPointerDown = false, ccStartX = 0, ccDragMoved = false;
      var ccPrevBtn = $('[data-rvw-carousel-prev]');
      var ccNextBtn = $('[data-rvw-carousel-next]');
      var ccDots = $$('[data-dot-index]');

      var ccRender = function () {
        var total = ccSlides.length;
        var prevI = (ccCurrent - 1 + total) % total;
        var nextI = (ccCurrent + 1) % total;
        var prev2 = (ccCurrent - 2 + total) % total;
        var next2 = (ccCurrent + 2) % total;
        var prev3 = (ccCurrent - 3 + total) % total;
        var next3 = (ccCurrent + 3) % total;
        var maxH = 0, activeH = 0;
        var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

        ccSlides.forEach(function (slide, i) {
          slide.classList.remove('is-active', 'is-prev', 'is-next', 'is-prev-2', 'is-next-2', 'is-prev-3', 'is-next-3', 'is-far');
          if (i === ccCurrent) slide.classList.add('is-active');
          else if (i === prevI) slide.classList.add('is-prev');
          else if (i === nextI) slide.classList.add('is-next');
          else if (total > 3 && i === prev2) slide.classList.add('is-prev-2');
          else if (total > 3 && i === next2) slide.classList.add('is-next-2');
          else if (total > 6 && i === prev3) slide.classList.add('is-prev-3');
          else if (total > 6 && i === next3) slide.classList.add('is-next-3');
          else slide.classList.add('is-far');

          var card = slide.querySelector('.rvw-carousel__card');
          if (card) {
            card.style.minHeight = '';
            var h = card.offsetHeight;
            if (h > maxH) maxH = h;
            if (i === ccCurrent) activeH = h;
          }
        });

        ccDots.forEach(function (d, i) { d.classList.toggle('is-active', i === ccCurrent); });

        if (isMobile) {
          if (activeH) ccViewport.style.height = activeH + 'px';
        } else if (maxH) {
          ccSlides.forEach(function (slide) {
            var card = slide.querySelector('.rvw-carousel__card');
            if (card) card.style.minHeight = maxH + 'px';
          });
          ccViewport.style.height = maxH + 'px';
        }
      };

      var ccGoTo = function (index) {
        var total = ccSlides.length;
        ccCurrent = ((index % total) + total) % total;
        ccRender();
      };

      if (ccPrevBtn) ccPrevBtn.addEventListener('click', function () { ccGoTo(ccCurrent - 1); });
      if (ccNextBtn) ccNextBtn.addEventListener('click', function () { ccGoTo(ccCurrent + 1); });
      ccDots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = parseInt(d.getAttribute('data-dot-index'), 10);
          if (!isNaN(i)) ccGoTo(i);
        });
      });

      ccViewport.addEventListener('pointerdown', function (e) { ccPointerDown = true; ccStartX = e.clientX; ccDragMoved = false; });
      var ccEndDrag = function (e) {
        if (!ccPointerDown) return;
        ccPointerDown = false;
        var dx = e.clientX - ccStartX;
        if (Math.abs(dx) > 10) { ccDragMoved = true; ccGoTo(ccCurrent + (dx > 0 ? -1 : 1)); }
      };
      ccViewport.addEventListener('pointerup', ccEndDrag);
      ccViewport.addEventListener('pointercancel', ccEndDrag);
      ccViewport.addEventListener('pointerleave', function (e) { if (ccPointerDown) ccEndDrag(e); });

      ccSlides.forEach(function (slide, i) {
        var card = slide.querySelector('.rvw-carousel__card');
        if (!card) return;
        card.addEventListener('click', function () {
          if (ccDragMoved) { ccDragMoved = false; return; }
          if (i !== ccCurrent) { ccGoTo(i); return; }
          openQuote(slide);
        });
      });

      if (ccWrapper) ccWrapper.classList.add('is-ready');
      ccRender();
      window.addEventListener('resize', ccRender);
      window.addEventListener('load', ccRender);
    }

    /* ---------- open / close ---------- */
    var form = $('[data-rvw-form]');
    var openBtn = $('[data-rvw-open]');
    var cancelBtns = $$('[data-rvw-cancel]'); // top "X" + bottom "Anuluj" both collapse the form
    if (openBtn && form) {
      openBtn.addEventListener('click', function () {
        form.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        form.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'center' });
        var first = $('[data-rvw-star-radio]');
        if (first) setTimeout(function () { first.focus(); }, 120);
      });
    }
    if (cancelBtns.length && form) {
      cancelBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          form.hidden = true;
          if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
        });
      });
    }

    /* ---------- star input ---------- */
    var starWrap = $('[data-rvw-starinput]');
    var starLabels = $$('.rvw-star-label');
    var starRadios = $$('[data-rvw-star-radio]');
    function paint(upTo) {
      starLabels.forEach(function (l) {
        var v = parseInt(l.getAttribute('data-rvw-star'), 10);
        l.classList.toggle('is-lit', v <= upTo);
      });
    }
    function selectedRating() {
      var c = starRadios.filter(function (r) { return r.checked; })[0];
      return c ? parseInt(c.value, 10) : 0;
    }
    starLabels.forEach(function (l) {
      var v = parseInt(l.getAttribute('data-rvw-star'), 10);
      l.addEventListener('mouseenter', function () { if (starWrap) starWrap.classList.add('is-hovering'); paint(v); });
    });
    if (starWrap) {
      starWrap.addEventListener('mouseleave', function () { starWrap.classList.remove('is-hovering'); paint(selectedRating()); });
    }
    starRadios.forEach(function (r) {
      r.addEventListener('change', function () { paint(selectedRating()); });
    });

    /* ---------- photo upload ---------- */
    var images = []; // [{ dataUrl, name }]
    var fileInput = $('[data-rvw-file]');
    var thumbs = $('[data-rvw-thumbs]');
    var uploadText = $('[data-rvw-upload-text]');
    var uploadTextDefault = uploadText ? uploadText.textContent : '';

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var files = Array.prototype.slice.call(fileInput.files || []);
        fileInput.value = ''; // allow re-selecting the same file
        var slots = maxImages - images.length;
        if (slots <= 0) { showErr(fmt(MSG.err_max_images, maxImages)); return; }
        var accepted = [];
        for (var i = 0; i < files.length && accepted.length < slots; i++) {
          var f = files[i];
          if (!/^image\//.test(f.type)) { showErr(MSG.err_image_type); continue; }
          if (f.size > MAX_BYTES) { showErr(MSG.err_image_size); continue; }
          accepted.push(f);
        }
        if (files.length > slots) showErr(fmt(MSG.err_max_images, maxImages));
        accepted.forEach(function (f) {
          downscale(f, function (dataUrl) {
            if (images.length >= maxImages) return;
            images.push({ dataUrl: dataUrl, name: f.name });
            renderThumbs();
          });
        });
      });
    }

    function renderThumbs() {
      if (!thumbs) return;
      thumbs.innerHTML = '';
      images.forEach(function (img, idx) {
        var wrap = document.createElement('div');
        wrap.className = 'rvw-thumb';
        var el = document.createElement('img');
        el.src = img.dataUrl; el.alt = '';
        var x = document.createElement('button');
        x.type = 'button'; x.className = 'rvw-thumb-x'; x.setAttribute('aria-label', 'x'); x.textContent = '×';
        x.addEventListener('click', function () { images.splice(idx, 1); renderThumbs(); });
        wrap.appendChild(el); wrap.appendChild(x);
        thumbs.appendChild(wrap);
      });
      if (uploadText) {
        uploadText.textContent = images.length ? (images.length + ' / ' + maxImages) : uploadTextDefault;
      }
    }

    function downscale(file, done) {
      var url = URL.createObjectURL(file);
      var im = new Image();
      im.onload = function () {
        var w = im.naturalWidth, h = im.naturalHeight;
        var scale = Math.min(1, MAX_DIM / Math.max(w, h));
        var cw = Math.max(1, Math.round(w * scale));
        var ch = Math.max(1, Math.round(h * scale));
        var canvas = document.createElement('canvas');
        canvas.width = cw; canvas.height = ch;
        try {
          canvas.getContext('2d').drawImage(im, 0, 0, cw, ch);
          var out = canvas.toDataURL('image/jpeg', 0.82);
          done(out);
        } catch (e) { /* tainted canvas / decode fail — skip */ }
        URL.revokeObjectURL(url);
      };
      im.onerror = function () { URL.revokeObjectURL(url); showErr(MSG.err_image_type); };
      im.src = url;
    }

    /* ---------- submit ---------- */
    var errorEl = $('[data-rvw-error]');
    var submitBtn = $('[data-rvw-submit]');
    var successEl = $('[data-rvw-success]');

    function showErr(msg) { if (errorEl) errorEl.textContent = msg || ''; }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        showErr('');
        var hp = form.querySelector('.rvw-hp'); if (hp && hp.value) return; // honeypot

        var rating = selectedRating();
        var author = valOf('author');
        var email = valOf('email');
        var title = valOf('title');
        var body = valOf('body');
        var consent = $('[data-rvw-consent]');

        if (!rating) return showErr(MSG.err_rating);
        if (!author) return showErr(MSG.err_author);
        if (!validEmail(email)) return showErr(MSG.err_email);
        if (body.length < 3) return showErr(MSG.err_body);
        if (consent && !consent.checked) return showErr(MSG.err_consent);
        if (!endpoint) return showErr(MSG.err_config);

        submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true');
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            product_id: root.dataset.productId,
            product_handle: root.dataset.productHandle,
            rating: rating,
            author: author,
            email: email,
            title: title,
            body: body,
            images: images.map(function (i) { return i.dataUrl; }),
            locale: cfg.locale
          })
        })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (res.status === 409 || (res.d && res.d.error === 'already_reviewed')) {
              return finishSuccess(MSG.already_reviewed);
            }
            if (!res.ok || !res.d || res.d.ok === false) { throw new Error((res.d && res.d.error) || 'failed'); }
            finishSuccess();
          })
          .catch(function () { showErr(MSG.err_generic); })
          .finally(function () { submitBtn.disabled = false; submitBtn.removeAttribute('aria-busy'); });
      });
    }

    function finishSuccess(customText) {
      // Hide the input fields, keep the success note. New review is queued
      // server-side; it appears on the next page render (or after moderation).
      $$('.rvw-field, .rvw-grid2, .rvw-consent, .rvw-form-actions, .rvw-error').forEach(function (el) { el.hidden = true; });
      if (successEl) {
        if (customText) { var t = successEl.querySelector('.rvw-success-text'); if (t) t.textContent = customText; }
        successEl.hidden = false;
      }
    }

    function valOf(k) { var el = $('[data-rvw-input="' + k + '"]'); return el ? el.value.trim() : ''; }
    function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    /* ---------- lightbox ---------- */
    var lb = $('[data-rvw-lightbox]');
    var lbImg = $('[data-rvw-lightbox-img]');
    var lbClose = $('[data-rvw-lightbox-close]');
    function openLb(src) { if (!lb || !lbImg) return; lbImg.src = src; lb.hidden = false; lb.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('is-locked'); }
    function closeLb() { if (!lb) return; lb.hidden = true; lb.setAttribute('aria-hidden', 'true'); if (lbImg) lbImg.src = ''; document.documentElement.classList.remove('is-locked'); }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-rvw-photo]');
      if (btn) { openLb(btn.getAttribute('data-rvw-photo')); }
    });
    if (lbClose) lbClose.addEventListener('click', closeLb);
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb && !lb.hidden) closeLb(); });

    // In the theme editor, reveal the form so it's editable at a glance.
    if (cfg.inEditor && form) form.hidden = false;
  }

  function readConfig(root) {
    var tag = root.querySelector('[data-rvw-config]');
    if (!tag) return {};
    try { return JSON.parse(tag.textContent); } catch (e) { return {}; }
  }
  function fmt(tpl, n) { return String(tpl || '').replace('{n}', n); }
  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-product-reviews]')).forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when the section is re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-product-reviews]');
    if (el) initSection(el);
  });
})();
